var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"has-addons is-flex is-align-items-center",attrs:{"data-cy":"tabs"}},[(_setup.route.name?.includes('prefix-collection-id'))?_c(_setup.TabOnCollection):_c(_setup.TabOnExplore)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }